<template>
  <div>
    <div class="legal-hero">
      <div class="col">
        <div class="legal-eyebrow">Legal</div>
        <h1 class="legal-title">Política de Privacidade</h1>
      </div>
    </div>
    <div class="col legal-col">
      <div class="legal-bloco" v-revela>
        <p class="legal-updated">Última atualização: julho de 2026</p>

        <h3 class="legal-h">Dados que coletamos</h3>
        <p class="legal-p">Ao solicitar contato ou contratar um serviço, coletamos apenas os dados necessários para a operação: nome, nome da empresa, número de WhatsApp, e-mail e a mensagem enviada. Não coletamos dados de navegação além dos essenciais ao funcionamento do site.</p>

        <h3 class="legal-h">Como usamos os dados</h3>
        <p class="legal-p">Os dados são usados exclusivamente para: responder solicitações, executar os serviços contratados, enviar avisos de status pelo WhatsApp e emitir comprovantes. Não vendemos, alugamos nem compartilhamos seus dados com terceiros para fins de marketing.</p>

        <h3 class="legal-h">Compartilhamento</h3>
        <p class="legal-p">Os dados de terceiros envolvidos numa operação (nome, endereço, telefone) são usados apenas para a execução do serviço contratado. Dados fiscais podem ser compartilhados com autoridades quando exigido por lei.</p>

        <h3 class="legal-h">Armazenamento e segurança</h3>
        <p class="legal-p">Os registros são mantidos pelo prazo necessário ao cumprimento de obrigações legais e fiscais. Adotamos medidas razoáveis de segurança para proteger as informações contra acesso não autorizado.</p>

        <h3 class="legal-h">Seus direitos (LGPD)</h3>
        <p class="legal-p">Nos termos da Lei Geral de Proteção de Dados (Lei 13.709/2018), você pode solicitar a qualquer momento: confirmação do tratamento, acesso, correção ou exclusão dos seus dados. Basta entrar em contato pelo WhatsApp ou e-mail informados no rodapé.</p>

        <h3 class="legal-h">Controlador</h3>
        <p class="legal-p">{{ EMPRESA.razao }}<br>CNPJ: {{ EMPRESA.cnpj }}<br>{{ EMPRESA.endereco }} — {{ EMPRESA.cidade }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { EMPRESA } from '@/config/contato'
</script>

<style src="@/assets/legal.css" scoped></style>
